module.exports = __webpack_public_path__ + "static/media/bg.107a63f7.png";